export const ConnectionPrefix = {
  Game: 'game',
};

export const GameLiveConnectionMethod = {
  Ping: 'Ping',
  Spin: 'Spin',
  DemoSpin: 'DemoSpin',
  GameOpen: 'GameOpen',
  BalanceUpdate: 'BalanceUpdate',
  JackpotConnect: 'JackpotConnect',
  GetInitialState: 'GetInitialState',
  MaintenanceNotify: 'MaintenanceNotify',
  JackpotWinnerInfo: 'JackpotWinnerInfo',
  GetDemoInitialState: 'GetDemoInitialState',
  GetBalance: 'GetBalance',
  GetBalanceResult: 'GetBalanceResult',
  GetTournamentBalanceResult: 'GetTournamentBalanceResult',
  GetTournamentBalance: 'GetTournamentBalance',
  Error: 'error',
  Gamble: 'Gamble',
  DemoGamble: 'DemoGamble',
  SpinCollect: 'SpinCollect',
  DemoSpinCollect: 'DemoSpinCollect',
  GetTournamentInfo: 'GetTournamentInfo',
  GetBoostedJackpotWin: 'GetBoostedJackpotWin',
};

export const GameLiveConnectionEvent = {
  DemoInitialStateResult: 'DemoInitialStateResult',
  InitialStateResult: 'InitialStateResult',
  DemoSpinResult: 'DemoSpinResult',
  SpinResult: 'SpinResult',
  FreeBetAwarded: 'FreeBetAwarded',
  JackpotUpdate: 'JackpotUpdate',
  JackpotWin: 'JackpotWin',
  JackpotWinnerInfoResult: 'JackpotWinnerInfoResult',
  JackpotSceneResult: 'JackpotSceneResult',
  BoostedJackpotWinnerInfoResult: 'BoostedJackpotWinnerInfoResult',
  BoostedJackpotActivationInfoResult: 'BoostedJackpotActivationInfoResult',
  BoostedJackpotExpirationInfoResult: 'BoostedJackpotExpirationInfoResult',
  GetBoostedJackpotWinResult: 'BoostedJackpotWinResult',
  OpenJackpotSceneItem: 'OpenJackpotSceneItem',
  OpenJackpotScene: 'OpenJackpotScene',
  JackpotSceneItemResult: 'JackpotSceneItemResult',
  GambleResult: 'GambleResult',
  DemoGambleResult: 'DemoGambleResult',
  SpinCollectResult: 'SpinCollectResult',
  DemoSpinCollectResult: 'DemoSpinCollectResult',
  DemoSpinAvalancheResult: 'DemoSpinAvalancheResult',
  SpinAvalancheResult: 'SpinAvalancheResult',
  GetTournamentInfoResult: 'GetTournamentInfoResult',
};

export const CommonConnectionsMethod = {
  Reconnecting: 'Reconnect',
  Reconnected: 'Reconnected',
  ConnectionClose: 'ConnectionClose',
  UnderMaintenance: 'UnderMaintenance',
};
